import { Result } from 'core/infrastructure';
import { Preconditions } from 'core/infrastructure-next';
import * as TakeOutOrderStore from './TakeOutOrderStore';
import { Command } from 'pos/common';
import { Res, Permission } from 'core/api';
import { Message } from 'core/ui-next/modal';

declare global {
	interface CommandType {
		rejectTakeOutOrder: (orderId: number) => Promise<Result>
	}
}

Command.register('rejectTakeOutOrder', Preconditions.and(Preconditions.ensure(Permission.SalesOrder_Reject), Preconditions.ensureIsNotLite), async (orderId: number): Promise<Result> => {
	const result = await Message.confirm(Res.Msg.MSG_CONFIRM_REJECT_SALES_ORDER());
	if (!result.ok)
		return Result.error();

	await TakeOutOrderStore.reject(orderId);
	return Result.ok();
});
